import { endpoint } from '../shared-api.service';
import { PublicSharedApiService } from '../public-shared-api.service';

export type LoginConfigResponseDto = {
  allowOGPSSO: boolean;
};

const publicSharedApi = new PublicSharedApiService(endpoint);

export const getLoginConfig = async (): Promise<LoginConfigResponseDto> => {
  return publicSharedApi.get<LoginConfigResponseDto>({ path: 'login-config' });
};
